import { Col, Container, Row } from "reactstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const Galery = () => {

  const listGalery = [
    { name:"Professor Hegarty Marks 30 Years of Engagement with China", img:"assets/images/gallery/gallery1.webp" },
    { name:"Alison Canavan at Griffith College Cork", img:"assets/images/gallery/gallery2.webp" },
    { name:"Celebrating Culture, Community and Learning at Griffith College", img:"assets/images/gallery/gallery3.webp" },
    { name:"Griffith College Ireland", img:"assets/images/gallery/gallery4.webp" },
    { name:"Griffith College Cork MSc Students Share Insights at HECA Research Conference", img:"assets/images/gallery/gallery5.webp" },
    { name:"Students Plan to Launch New Griffith College Magazine", img:"assets/images/gallery/gallery6.webp" },
  ]

  return (
    <section className="section" id="galery">
      <Container>
        <Row className="">
            <LightGallery
              speed={500}
              plugins={[lgThumbnail, lgZoom]}
              selector=".masonry-item"
              download={false}
            >
              <div className="masonry">
                {listGalery.map((item, id) => (
                  <a 
                    key={id} 
                    href={item.img}
                    className="masonry-item"
                  >
                    <img 
                      alt={item.name} 
                      src={item.img} 
                      className="img-fluid" 
                    />
                  </a>  
                ))}      
              </div>            
            </LightGallery>   
        </Row>
      </Container>
    </section>
  );
};

export default Galery;